import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Box = styled.div`
  padding: 16px;
  @media screen and (max-width: 320px) {
    padding: 16px 8px;
  }
  background: #fff;
  border-radius: 16px 16px 0px 0px;
  min-height: 400px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.div`
  color: #FFF;
  font-size: 14px;
  font-weight: 600;
  padding: 3px;
  line-height: 35px;
`;

const Text = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #808080;
  padding: 16px 16px 16px 8px;
  background: #DEEDFF;
  border-radius: 0px 0px 12px 12px;
  text-align: left;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #0161BF;
  border-radius: 12px 12px 0px 0px;
`;

const TermsConditions = ({ title, rule }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <TitleWrapper>
        <Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
      </TitleWrapper>
      <Text dangerouslySetInnerHTML={{ __html: rule }} />
    </Box>
  );
};

export default TermsConditions;
